<template lang="pug">
  .view-control-lessons-edit
    //- Хлебные крошки
    //- ui-breadcrumbs(:items="breadcrumb")

    b-tabs.ui-tabs(v-model="activeTab")

      //- TAB: Общие данные
      b-tab-item
        template(slot="header")
          b-icon(icon="information-outline")
          span Общие данные
          b-icon(v-if="lesson.$isChanged" icon="asterisk" size="is-small" type='id-danger')
        layout-form(:value="lesson" form='lesson' back-link)

      //- TAB: Презентация
      b-tab-item
        template(slot="header")
          b-icon(icon="poll")
          span Презентация
          b-icon(v-if="presentation.$isChanged" icon="asterisk" size="is-small" type='id-danger')
        layout-form(:value="presentation" form='presentation' back-link)

      //- TAB: Доступ
      b-tab-item
        template(slot="header")
          b-icon(icon="lock-open")
          span Доступ
        layout-form(v-if="lesson.id" :value="lesson" form='resource-access' back-link)

</template>

<script>
import Lesson from '@/models/Lesson';
import Presentation from '@/models/Presentation';

export default {
  name: 'view-control-lessons-edit',

  data: () => ({
    lesson: new Lesson(),
    activeTab: 0,
    presentation: new Presentation(),
  }),

  computed: {
    // breadcrumb() {
    //   return [
    //     { route: { name: 'control.lessons' }, name: 'Материалы' },
    //     { name: this.lesson.name, active: true },
    //   ];
    // },
  },

  async created() {
    await this.lesson.$find(this.$route.params.id, { include: 'presentations.slides,category' });

    if (this.lesson.presentations && this.lesson.presentations.count() > 0) {
      this.presentation = this.lesson.presentations.first();
    }
  },
};
</script>
